import { render, staticRenderFns } from "./TransferDialog.vue?vue&type=template&id=9c1c5dae&scoped=true&"
import script from "./TransferDialog.vue?vue&type=script&lang=ts&"
export * from "./TransferDialog.vue?vue&type=script&lang=ts&"
import style0 from "./TransferDialog.vue?vue&type=style&index=0&id=9c1c5dae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1c5dae",
  null
  
)

export default component.exports